import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightAlt = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 24,
	viewBox: "0 -960 960 960",
	width: 24,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m560-240-56-58 142-142H160v-80h486L504-662l56-58 240 240-240 240Z" })
});
export default SvgArrowRightAlt;
